import { render, staticRenderFns } from "./rectifyDetail.vue?vue&type=template&id=727d5d4a&scoped=true"
import script from "./rectifyDetail.vue?vue&type=script&lang=js"
export * from "./rectifyDetail.vue?vue&type=script&lang=js"
import style0 from "./rectifyDetail.vue?vue&type=style&index=0&id=727d5d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727d5d4a",
  null
  
)

export default component.exports